import { InstitutionEnum } from '../types/enums/institution.enum';

export const getCurrentInstitution = (): string | null => localStorage.getItem('institution');

export const isInstitution = (...institutions: InstitutionEnum[]): boolean => {
  const currentInstitution = getCurrentInstitution();
  return institutions.some((institution) => institution === currentInstitution);
};

// To enable Zurich insurance for another institution, add it to InstitutionEnum and list it here
export const isZurichChannelAllowed = (): boolean =>
  isInstitution(InstitutionEnum.CANAL_5, InstitutionEnum.CANAL_1, InstitutionEnum.GETNET);
